import { useState, useEffect } from 'react'
import "./radio.css"

function FM93() {
    
  useEffect(() => {
    const script = document.createElement('script');
  
    script.src = "./script1.js";
    script.async = true;
  
    document.body.appendChild(script);
  


    const script2 = document.createElement('script');
  
    script2.src = "./script2.js";
    script2.async = true;
  
    document.body.appendChild(script2);
  

  }, []);



    return (
    <div id="aD9owqfCpELDpjkwwrfDjCnDhT16b0F3w5Nmw5M=" className="mytuner-widget" data-target="396327" data-requires_initialization="true" data-autoplay="false" data-hidehistory="true" style={{"width": "100%", "max-width": "100%", "overflow": "hidden", "max-height": "500px", border: "1px solid rgb(129, 127, 128)", "border-radius": "6px"}}>
    <div id="aD9owqfCpELDpjkwwrfDjCnDhT16b0F3w5Nmw5M=top-bar" style={{"background": "rgb(113, 244, 176)","height": "75px", "width": "100%", "display": "block", "padding": "5px", "line-height": "65px"}}>
    <div id="aD9owqfCpELDpjkwwrfDjCnDhT16b0F3w5Nmw5M=play-button" class="main-play-button disabled" data-id="aD9owqfCpELDpjkwwrfDjCnDhT16b0F3w5Nmw5M="><div class="play-image"></div></div><a class="player-radio-link" href="http://mytuner-radio.com/th/%E0%B8%A7%E0%B8%B4%E0%B8%97%E0%B8%A2%E0%B8%B8/cool-fahrenheit-93-fm-396327/?utm_source=widget&amp;utm_medium=player" rel="nofollow" style={{"height": "100%", display: "inline-block", "line-height": "65px", cursor: "pointer"}}>
      <img src="https://static2.mytuner.mobi/media/tvos_radios/KvDHAwT62s.png" alt="COOL Fahrenheit 93 FM" style={{"float": "left", height: "74px", "margin-top": "-5px", "box-shadow": "black 0px 0px 3px -1px"}}/><span class="player-radio-name" style={{"margin-left": "10px", color: "rgb(61, 61, 61)", "font-weight": "bold", "font-size": "20px", "float": "left", "overflow": "hidden", "text-overflow": "ellipsis", "white-space": "nowrap"}}>COOL Fahrenheit 93 FM</span></a>
      <div class="volume-controls">
        <input id="aD9owqfCpELDpjkwwrfDjCnDhT16b0F3w5Nmw5M=volume-control" class="volume-control slider" max="100" min="1" orient="vertical" type="range" value="100"/><svg id="aD9owqfCpELDpjkwwrfDjCnDhT16b0F3w5Nmw5M=volume-indicator" class="volume-indicator" height="30" width="30" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style={{"fill": "grey", margin: "2px"}}><path d="M3 10v4c0 .55.45 1 1 1h3l3.29 3.29c.63.63 1.71.18 1.71-.71V6.41c0-.89-1.08-1.34-1.71-.71L7 9H4c-.55 0-1 .45-1 1zm13.5 2c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 4.45v.2c0 .38.25.71.6.85C17.18 6.53 19 9.06 19 12s-1.82 5.47-4.4 6.5c-.36.14-.6.47-.6.85v.2c0 .63.63 1.07 1.21.85C18.6 19.11 21 15.84 21 12s-2.4-7.11-5.79-8.4c-.58-.23-1.21.22-1.21.85z"></path></svg></div><a class="player-mytuner-logo" href="https://mytuner-radio.com?utm_source=widget&amp;utm_medium=player" rel="nofollow" style={{"display": "inline-block", "vertical-align": "top"}}><img src="https://mytuner-radio.com/static/icons/widgets/MyTuner_Logo/MyTunerLogo_Normal.png" alt="Listen on myTuner radio!" style={{"height": "36px", width: "84px", "vertical-align": "middle"}}/></a></div><ul id="aD9owqfCpELDpjkwwrfDjCnDhT16b0F3w5Nmw5M=song-history" data-border="1" data-bordercolor="#817f80" style={{width: "100%", "background-color": "rgb(238, 238, 238)", "max-height": 'calc(415px)', padding: '0px', margin: "0px", "overflow-y": "scroll"}}></ul>



    </div>

    )
}

export default FM93